import React, { useContext } from 'react';

import { StyledLink } from './ButtonPrimary.styles';
import * as variables from '../../../common/styles/variables';
import { iconsToUse } from '../../styles/themes';
import { Icon } from '../Icon/Icon';
import { ThemeContext } from 'styled-components';
import { white } from '../../styles/colors';

type ButtonPrimaryProps = {
  style?: any;
  title: string;
  route?: string;
  href?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  disabled: boolean;
  className?: string | undefined;
  tabIndex?: number;
  target?: string;
  outlined?: boolean;
  textOnly?: boolean;
  children?: React.ReactNode;
  borderRadiusType?: 'squared' | 'none';
  icon?: string;
};

const defaultProps = {
  route: '',
  title: '',
  onClick: undefined,
  disabled: false,
  outlined: false,
  textOnly: false,
  tabIndex: '',
};

const ButtonPrimary = (props: ButtonPrimaryProps) => {
  const theme = useContext(ThemeContext);

  const requiredProps: { rel?: string } = {};
  const { borderRadiusType, ...linkProps } = props;

  if (props.target === '_blank') {
    requiredProps.rel = 'noopener noreferrer';
  }
  return (
    <StyledLink {...linkProps} {...requiredProps} to={props.route} onClick={props.onClick} title={''}>
      {props.icon && (
        <Icon
          className={`icon mr-1 mt-n1 ${props.disabled ? 'icon--disabled' : ''}`}
          size={variables.iconSizeSmall}
          icon={(iconsToUse as any)[`${props.icon}`]}
          color={white}
        />
      )}
      {props.title || props.children}
    </StyledLink>
  );
};

ButtonPrimary.defaultProps = defaultProps;

export { ButtonPrimary };
